import { U21ChipProps } from 'app/shared/u21-ui/components';
import { U21ActionEventChip } from 'app/shared/u21-ui/components/dashboard/dataChip/U21ActionEventChip';
import { U21AlertChip } from 'app/shared/u21-ui/components/dashboard/dataChip/U21AlertChip';
import { U21EntityChip } from 'app/shared/u21-ui/components/dashboard/dataChip/U21EntityChip';
import { U21InstrumentChip } from 'app/shared/u21-ui/components/dashboard/dataChip/U21InstrumentChip';
import { U21TransactionChip } from 'app/shared/u21-ui/components/dashboard/dataChip/U21TransactionChip';
import { U21AttachmentChip } from 'app/shared/u21-ui/components/dashboard/dataChip/U21AttachmentChip';

export enum U21DataChipType {
  ACTION_EVENT = 'ACTION_EVENT',
  ALERT = 'ALERT',
  ENTITY = 'ENTITY',
  INSTRUMENT = 'INSTRUMENT',
  TXN_EVENT = 'TXN_EVENT',
  ATTACHMENT = 'ATTACHMENT',
}

export type U21DataChipProps = {
  type: U21DataChipType;
  id: number | string;
  label: string;
  // External (customer) id for CGDO types. When provided, the entity/instrument/
  // action-event/txn-event chips use it to resolve the object in PG cache mode.
  externalId?: string;
} & Omit<U21ChipProps, 'id' | 'children'>;

export const U21DataChip = ({
  id,
  label,
  type,
  externalId,
  ...rest
}: U21DataChipProps) => {
  switch (type) {
    case U21DataChipType.ACTION_EVENT:
      return (
        <U21ActionEventChip
          id={id}
          externalId={externalId}
          label={label}
          {...rest}
        />
      );
    case U21DataChipType.ALERT:
      return <U21AlertChip id={id} label={label} {...rest} />;
    case U21DataChipType.ENTITY:
      return (
        <U21EntityChip id={id} externalId={externalId} name={label} {...rest} />
      );
    case U21DataChipType.INSTRUMENT:
      return (
        <U21InstrumentChip
          id={id}
          externalId={externalId}
          label={label}
          {...rest}
        />
      );
    case U21DataChipType.TXN_EVENT:
      return (
        <U21TransactionChip
          id={id}
          externalId={externalId}
          label={label}
          {...rest}
        />
      );
    case U21DataChipType.ATTACHMENT:
      return <U21AttachmentChip id={id} label={label} {...rest} />;
    default:
      return null;
  }
};
